export function testAccountName(name) {
    const nameRegex = /^(?!\.)[a-z1-5.]{1,12}(?!\.\.)$(?<!\.)/;

    if (name.match(nameRegex)) {
        return true;
    }
    return false;
}